module.exports = __webpack_public_path__ + "static/media/facebook-icon.b37c247b.svg";